export { SearchFormComposition } from './search-form-composition';
//# sourceMappingURL=index.js.map